<template>
  <div class="popup-wrapper" :class="{ 'showing': modal }">
    <div class="popup-card p25">
      <div class="d-flex justify-content-between align-items-center">
        <div class="font-bold">Close Investigation Customer Issue</div>
        <button @click="$emit('close-modal')" class="btn btn-for-close"><span class="icon-ico-close"></span></button>
      </div>
      <div class="inner-land">
        <div class="popup-item">
          <div class="row gap-2">
            <div>Please fill out the Close Investigation Customer Issue Form</div>
            <FormCloseStatus @close="onClose" v-model="data" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormCloseStatus from './Form/Close.vue'
import axios from '@/axios';
import moment from 'moment'
import { showErrorMessage } from '@/utils';
export default {
  name: '',
  components: {
    FormCloseStatus
  },
  props: ['modal', 'statusLabel'],
  data() {
    return {
      data: {
        status: 'request_close',
        date_result: '',
        result: ''
      }
    }
  },
  watch: {
    compareData: {
      handler: function () {
        if (this.detail?.status.label === 'Outstanding Internal & Customer - Cancel') {
          this.data.result = this.customerIssue?.result
          this.data.date_result = this.customerIssue?.date_result
        }
      }, deep: true
    }
  },
  methods: {
    async onClose() {
      try {
        await axios.put(`/fnc-customer-issues/${this.$route.params.id}`, {
          ...this.data,
          date_result: moment(this.data?.date_result, 'DD-MM-YYYY').format('YYYY-MM-DD')
        })
        this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
        this.$store.dispatch('getDetailFeedbackComplaintCustomerIssue', this.$route.params.id)
        this.$emit('close-modal')
      } catch (error) {
        showErrorMessage(error)
      }
    }
  },
  computed: {
    detail() {
      return this.$store.state?.feedbackComplaint?.detail
    },
    customerIssue() {
      return this.$store.state?.feedbackComplaint?.customerIssue
    },
    compareData() {
      return `${this.detail}|${this.customerIssue}`
    }
  }
}
</script>
